import React from 'react';
import TreatmentSummary from '../../containers/TreatmentSummary/TreatmentSummary';

export class TreatmentSummaryPage extends React.Component {
  render() {
    return (
      <TreatmentSummary />
    );
  }
}